import { hasGraphQLErrorCode } from "@/lib/utils/graphqlErrors";
import type { ViewMode } from "@/types/viewMode";
import { ErrorCodes } from "@ai-teach/types";
import { Button } from "@ai-teach/ui-web";
import type { ErrorLike } from "@apollo/client";
import { BiBookReader } from "react-icons/bi";
import { FaFolder, FaPaintBrush, FaRegNewspaper } from "react-icons/fa";

interface NoProjectFoundProps {
  itemType: "project" | "lesson" | "slide" | "vocabulary card";
  error: ErrorLike | undefined;
  refetch?: () => void;
}

export function NoItemFound({ itemType, error, refetch }: NoProjectFoundProps) {
  const iconMap = {
    project: {
      icon: <FaFolder />,
      color: "text-blue-500",
    },
    lesson: {
      icon: <FaRegNewspaper />,
      color: "text-green-500",
    },
    slide: {
      icon: <FaPaintBrush />,
      color: "text-pink-500",
    },
    "vocabulary card": {
      icon: <BiBookReader />,
      color: "text-orange-500",
    },
  };

  return (
    <div className="col-span-full">
      <div className=" flex flex-col justify-center items-center min-h-[230px] gap-2">
        <div className={`text-6xl ${iconMap[itemType].color}`}>{iconMap[itemType].icon}</div>
        <p className="text-xl font-medium card-title">
          {!error ? `No ${itemType}s found` : "Server Error, please try again!"}
        </p>

        {refetch && error && (
          <Button
            onClick={() => {
              refetch();
            }}
          >
            Try Again!
          </Button>
        )}
      </div>
    </div>
  );
}
